import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getRendicionesFondos } from '../../helpers/api_helper';

const useObtenerRendicionesFondos = (limit = 100, refresh = 0) => {
    const [rendiciones, setRendiciones] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    useEffect(() => {
        const fetchRendiciones = async () => {
            if (!tenantId) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getRendicionesFondos({
                    tenantId, limit
                });
                console.log('Response from API for rendiciones fondos:', response);
                if (Array.isArray(response))
                    setRendiciones(response);
            } catch (err) {
                const errorMessage = `Failed to fetch rendiciones fondos: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setRendiciones(null);
            } finally {
                setLoading(false);
            }
        };

        fetchRendiciones();
    }, [tenantId, limit, refresh]);

    return { rendiciones, loading, error };
};

export default useObtenerRendicionesFondos;